import { render } from '@duox/mix';
import App from './components/App';

const content: HTMLElement = document.querySelector('#app');

render(App, content);
